import React, { useEffect, useState } from "react"

import {
  Col,
  Container,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"

import classnames from "classnames"
import Step1 from "./Step1"
import Step2 from "./Step2"
import Step4 from "./Step4"
import Step3 from "./Step3"
import Step5 from "./Step5"
import InfoPopup from "components/InfoPopup"
import { useDispatch } from "react-redux"
import { getProductList, updatePvsData } from "../../../redux/actions/user"
import { useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import {
  fetchPvsCategory,
  fetchPvsKeyword,
  fetchPvsSubcategory,
  getPvsDetails,
} from "../../../redux/actions/pvs"
import { getUserDetailsRequest } from "../../../redux/actions/auth"
import PageLoader from "components/Common/PageLoader"
import { RESET_PVS_REGISTRATION } from "../../../redux/types/pvs"

const PVSRegistration = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  const { state } = location

  const [activeTab, setactiveTab] = useState(1)
  const [isOpen, setIsOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [showPriceInfo, setShowPriceInfo] = useState(true)

  const user = useSelector(state => state.auth.user)
  const pvsFormData = useSelector(state => state.pvs.pvsFormData)

  useEffect(() => {
    dispatch({ type: RESET_PVS_REGISTRATION })
    dispatch(fetchPvsKeyword({ offset: 1 }))
    dispatch(fetchPvsCategory({ offset: 1 }))
    // dispatch(getProductList({ offset: 1 }))
    dispatch(getUserDetailsRequest())
  }, [])

  useEffect(() => {
    if (pvsFormData && state && state.allowEdit) {
      dispatch(
        getPvsDetails({
          enc_pvs_entry_id: pvsFormData.enc_pvs_entry_id,
        })
      )
    }
    if (user && user.pvs_entries && user.pvs_entries.length > 0) {
      setIsLoading(false)
      let pendingPVS = user.pvs_entries.find(pvs => pvs.status === "pending" || pvs.status === "clarification")
      let paidPVS = user.pvs_entries.find(pvs => pvs.status === "paid")
      if (paidPVS) {
        navigate("/pvs-info", { replace: true })
      }
      if (pendingPVS) {
        setShowPriceInfo(false)
        dispatch(
          getPvsDetails({
            enc_pvs_entry_id: pendingPVS.enc_pvs_entry_id,
          })
        )
      } else {
        toggleTab(1)
        setIsLoading(false)
      }
    }
  }, [user])

  useEffect(() => {

    if (pvsFormData) {
      if (pvsFormData.active_tab >= 1) {
        if (pvsFormData.active_tab >= 5) {
          if (state && state.allowEdit) {
            toggleTab(1)
            setIsLoading(false)
          } else {
            setIsLoading(false)
            navigate("/confirm-registration")
          }
        } else {
          setIsLoading(false)
          toggleTab(pvsFormData.active_tab + 1)
        }
      }
    }
  }, [pvsFormData])

  useEffect(() => {
    const activeStepEl = document.querySelector(
      ".form-wizard-wrapper .steps li.current"
    )

    if (activeStepEl) {
      activeStepEl.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      })
    }
  }, [activeTab])

  const alternateProofs = [
    "Letter from your husband/guardian's employer on their company letterhead providing your local address proof.",
    "Gas bill or phone bill.",
    "Educational certificate.",
    "Marriage certificate with husband's Pune address proof.",
  ]

  const infoPopupMessage = (
    <>
      <div className="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-4">
        <h5 className="mb-0">
          Please read the instructions carefully before you upload your
          documents
        </h5>
      </div>

      <ul className="mb-0 ps-3">
        <li className="mb-3">
          One needs to be a PULA member on Facebook Group.
        </li>
        <li className="mb-3">
          One needs to mandatorily have a Pune Address Proof.
        </li>
        <li className="mb-3">
          If you wish to attach multiple documents as your address proof, club
          it in one picture and upload it.
        </li>
        <li className="mb-3">
          If you do not have a Pune address proof on your name, one of the below
          document should be uploaded that confirms your stay in Pune
          <ul className="mt-2 mb-0 ps-3">
            {alternateProofs.map(item => (
              <li key={item} className="mb-1">
                {item}
              </li>
            ))}
          </ul>
        </li>
        <li className="mb-3">
          One needs to mandatorily have a Pune Address Proof.
        </li>
        <li className="mb-3">
          Blur or unclear documents will not be considered.
        </li>
        <li>
          Upload image size limit is up to 8 MB only. Upload only .jpg, .png and
          .jpeg format images.
        </li>
      </ul>
    </>
  )

  const toggleInfoPopup = () => {
    setIsOpen(!isOpen)
  }

  function toggleTab(tab) {

    if (activeTab !== tab) {
      if (tab >= 1 && tab <= 5) {
        setactiveTab(tab)
      }
    }
  }

  document.title = "PVS Registration"

  if (showPriceInfo) {
    return (
      <div className="page-content" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <div className="container-fluid" style={{ paddingLeft: 0, paddingRight: 0 }}>
          <div
            className="newaward-maincontainer p-4"
            style={{
              minHeight: "calc(100vh - 70px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div className="congrats-box content-boxnew text-center">
              <h1 className="h1">One-Time Registration Fee</h1>
              <p className="text-muted mb-2">
                To complete your PULA Verified Seller registration, a one-time
                fee of{" "}
                <strong style={{ color: "#2d2d2d" }}>
                  ₹ 1,180
                </strong>{" "}
                is required. This covers verification, onboarding, and your
                digital seller identity on the platform.
              </p>
              <p className="text-muted mb-4" style={{ fontSize: "0.875rem" }}>
                Subtotal ₹ 1,000 + GST 18% (₹ 180)
              </p>

              <p className="text-muted mb-4" style={{ fontSize: "0.85rem" }}>
                <i className="bx bx-info-circle me-1"></i>
                Payment will be collected at the end of the registration
                process. Please complete all steps before proceeding to
                checkout.
              </p>

              <div className="d-flex justify-content-center">
                <button
                  className="primary-button"
                  onClick={() => setShowPriceInfo(false)}
                >
                  Proceed to Registration
                  <i className="mdi mdi-arrow-right ms-2"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col sm="12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0">PVS Registration</h4>
                <button
                  type="button"
                  className="btn btn-link p-0 text-primary text-decoration-none"
                  onClick={toggleInfoPopup}
                >
                  Read Instructions
                </button>
              </div>
              <div className="custom-form-horizontal form-horizontal form-wizard-wrapper wizard clearfix">
                <div className="steps clearfix">
                  <ul>
                    <NavItem
                      className={classnames({
                        current: activeTab === 1,
                        done: activeTab > 1,
                      })}
                    >
                      <NavLink
                        className={classnames({
                          current: activeTab === 1,
                          done: activeTab > 1,
                        })}
                      >
                        <span className="number">1</span> Personal Details
                      </NavLink>
                    </NavItem>
                    <NavItem
                      className={classnames({
                        current: activeTab === 2,
                        done: activeTab > 2,
                      })}
                    >
                      <NavLink
                        className={classnames({
                          active: activeTab === 2,
                          done: activeTab > 2,
                        })}
                      >
                        <span className="number">2</span> Documents
                      </NavLink>
                    </NavItem>
                    <NavItem
                      className={classnames({
                        current: activeTab === 3,
                        done: activeTab > 3,
                      })}
                    >
                      <NavLink
                        className={classnames({
                          active: activeTab === 3,
                          done: activeTab > 3,
                        })}
                      >
                        <span className="number">3</span>
                        ID Card
                      </NavLink>
                    </NavItem>
                    <NavItem
                      className={classnames({
                        current: activeTab === 4,
                        done: activeTab > 4,
                      })}
                    >
                      <NavLink
                        className={classnames({
                          active: activeTab === 4,
                          done: activeTab > 4,
                        })}
                      >
                        <span className="number">4</span>
                        Business Details
                      </NavLink>
                    </NavItem>
                    <NavItem
                      className={classnames({
                        current: activeTab === 5,
                        done: activeTab > 5,
                      })}
                    >
                      <NavLink
                        className={classnames({
                          active: activeTab === 5,
                          done: activeTab > 5,
                        })}
                      >
                        <span className="number">5</span>
                        Billing Details
                      </NavLink>
                    </NavItem>
                  </ul>
                </div>
                <div className="content clearfix">
                  <TabContent activeTab={activeTab} className="body">
                    <TabPane tabId={1}>
                      <Step1 activeTab={activeTab} toggleTab={toggleTab} />
                    </TabPane>
                    <TabPane tabId={2}>
                      <Step2 activeTab={activeTab} toggleTab={toggleTab} />
                    </TabPane>
                    <TabPane tabId={3}>
                      <Step3 activeTab={activeTab} toggleTab={toggleTab} />
                    </TabPane>
                    <TabPane tabId={4}>
                      <Step4 activeTab={activeTab} toggleTab={toggleTab} />
                    </TabPane>
                    <TabPane tabId={5}>
                      <Step5 activeTab={activeTab} toggleTab={toggleTab} />
                    </TabPane>
                  </TabContent>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <InfoPopup
          isOpen={isOpen}
          toggle={toggleInfoPopup}
          message={infoPopupMessage}
          title="Instructions"
          size="xl"
          btnClass="default-btn"
          modalFooterClass="modalfooter-pvs"
        />
        <PageLoader isLoading={isLoading} />
      </div>
    </React.Fragment>
  )
}

export default PVSRegistration
